import { rem } from 'polished'
import styled from 'styled-components'

export const Root = styled.h2`
  font-weight: 800;
  font-size: ${rem(14)};
  line-height: ${rem(21)};
  letter-spacing: 0.05em;
  text-transform: uppercase;
`
